const getCustomerCategoriesCount = (rawTransactions, selectedStore) => {
  const oneYearAgo = new Date();
  oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);

  const sixMonthsAgo = new Date();
  sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);

  const threeMonthsAgo = new Date();
  threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);

  const currentDate = new Date();
  const customerMap = new Map();

  // Flatten nested transactions array per transaction
  const flatTransactions = rawTransactions.flatMap((transaction) =>
    transaction.transactions?.map((innerTran) => ({
      ...innerTran,
      cust_name: innerTran.cust_name || transaction.cust_name,
      cust_phone: innerTran.cust_phone || transaction.cust_phone,
      cust_email: innerTran.cust_email || transaction.cust_email,
      cust_mobile: innerTran.cust_mobile || transaction.cust_mobile,
      store_code: innerTran.store_code || transaction.store_code,
    }))
  );

  flatTransactions.forEach((transaction) => {
    const storeCode = transaction.store_code?.replace("ANGELSPIZZA_", "");
    if (selectedStore !== "All" && storeCode !== selectedStore) {
      return;
    }

    const tranDate = new Date(transaction.tran_date);
    if (tranDate < oneYearAgo) return;

    const customerKey =
      transaction.cust_name === "-"
        ? `${transaction.cust_phone}_${tranDate.getTime()}`
        : `${transaction.cust_phone}_${transaction.cust_name}`;

    const existingCustomer = customerMap.get(customerKey);
    const customer = existingCustomer || {
      custPhone: transaction.cust_phone,
      custName: transaction.cust_name,
      totalSpend: 0,
      purchaseCount: 0,
      lastPurchaseDate: tranDate,
      custEmail: transaction.cust_email,
      custMobile: transaction.cust_mobile,
      store: transaction.store_code,
      barangay: transaction.cust_barangay,
      address: transaction.cust_address,
      birthday: transaction.cust_birthday,
      card: transaction.cust_card,
      notes: transaction.cust_notes,
      landmark: transaction.landmark,
      apc: transaction.apcnumber,
      deltime: transaction.deltime,
      transactions: [],
    };

    const total = parseFloat(transaction.total);
    customer.totalSpend += total;
    customer.purchaseCount += 1;

    if (tranDate > customer.lastPurchaseDate) {
      customer.lastPurchaseDate = tranDate;
      customer.daysSinceLastPurchase = Math.floor(
        (currentDate - tranDate) / (1000 * 60 * 60 * 24)
      );
    }

    customer.transactions.push({
      date: transaction.tran_date,
      totalSpend: total,
      storeSpend: transaction.store_code,
      tranId: transaction.tran_id,
    });

    customerMap.set(customerKey, customer);
  });

  const categories = {
    loyalists: [],
    potentialLoyalists: [],
    promising: [],
    hesitant: [],
    needAttention: [],
    detractors: [],
    customers: [],
  };

  customerMap.forEach((customer) => {
    const totalSpend = customer.totalSpend;
    const purchaseCount = customer.purchaseCount;
    const daysSinceLastPurchase =
      customer.daysSinceLastPurchase ||
      Math.floor(
        (currentDate - new Date(customer.lastPurchaseDate)) /
          (1000 * 60 * 60 * 24)
      );

    if (totalSpend >= 10000 || purchaseCount >= 10) {
      categories.loyalists.push(customer);
    } else if (totalSpend >= 8000 || purchaseCount >= 8) {
      categories.potentialLoyalists.push(customer);
    } else if (totalSpend >= 6000 || purchaseCount >= 6) {
      categories.promising.push(customer);
    } else if (totalSpend >= 4000 || purchaseCount >= 4) {
      categories.hesitant.push(customer);
    } else if (totalSpend >= 2000 || purchaseCount >= 2) {
      categories.needAttention.push(customer);
    } else if (totalSpend >= 1000 || purchaseCount === 1) {
      categories.detractors.push(customer);
    }
  });

  return categories;
};

export default getCustomerCategoriesCount;
